export default "__VITE_ASSET__DsVrYFjT__"